// tslint:disable
export enum ContactInfoType {
    /**
     * @description UNKNOWN
     */
    UNKNOWN = 0,
    /**
     * @description PHONE
     */
    PHONE = 1,
    /**
     * @description MOBILE
     */
    MOBILE = 2,
    /**
     * @description FAX
     */
    FAX = 3,
    /**
     * @description WEB
     */
    WEB = 4,
    /**
     * @description E-MAIL
     */
    EMAIL = 5,
    /**
     * @description DO NOT CALL
     */
    DONOTCALL = 6,
    /**
     * @description FACEBOOK
     */
    FACEBOOK = 7,
    /**
     * @description TWITTER
     */
    TWITTER = 8,
    /**
     * @description LINKEDIN
     */
    LINKEDIN = 9,
    /**
     * @description GOOGLEPLUS
     */
    GOOGLEPLUS = 10,
    /**
     * @description YOUTUBE
     */
    YOUTUBE = 11,
    /**
     * @description Text
     */
    Text = 12,
    /**
     * @description Mail
     */
    Mail = 13,
    /**
     * @description MANGO
     */
    MANGO = 14,
}
(ContactInfoType as any)['TEXT'] = 12;
(ContactInfoType as any)['MAIL'] = 13;
